<template>
  <div class="login-spacing">
    <div v-if="isTokenValid === false">
      <b-alert variant="danger" show>
        {{ $t('resetpassword.tokenInvalid') }}<br>
        <router-link to="/passwort-vergessen">Neues Passwort anfordern</router-link>
      </b-alert>
    </div>
    <div v-else>
      <h1>Neues Passwort setzen</h1>
      <div class="login-form-wrapper">

        <b-alert v-model="hasUnknownError" variant="danger">
          {{ unknownErrorMessage }}
        </b-alert>

        <b-alert v-model="hasError" variant="danger">
          {{ errorMessage }}
        </b-alert>

        <b-alert v-model="isSucceded" variant="success">
          {{ $t('resetpassword.success') }}<br>
          <router-link to="/">Login</router-link>
        </b-alert>

        <validation-observer ref="observer" v-slot="{ passes }">
          <b-form @submit.prevent="passes(onSubmit)">

            <validation-provider vid="newPassword" rules="required|min:5" ref="newPassword" name="newPassword" v-slot="{ valid, errors, changed }">
              <b-form-group id="input-group-new-password" label="Passwort" label-for="input-new-password">
                <b-form-input
                  id="input-new-password"
                  v-model="form.newPassword"
                  :state="onValidateField(valid, errors, changed)"
                  type="password"
                  placeholder="Geben Sie Ihr neues Passwort an"
                ></b-form-input>
                <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <validation-provider vid="newPasswordConfirm" rules="required|confirmed:newPassword" name="newPasswordConfirm" v-slot="{ valid, errors, changed }">
              <b-form-group id="input-group-confirm-password" label="Passwort wiederholen" label-for="input-confirm-password">
                <b-form-input
                  id="input-password-confirm"
                  v-model="form.newPasswordConfirm"
                  :state="onValidateField(valid, errors, changed)"
                  type="password"
                  placeholder="Wiederholen Sie Ihr neues Passwort"
                ></b-form-input>
                <b-form-invalid-feedback class="input-live-feedback">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <b-button type="submit" variant="primary" class="w-100" disabled v-if="isSubmitting">
              <b-spinner small></b-spinner>
              Neues Passwort setzen
            </b-button>
            <b-button type="submit" variant="primary" class="w-100" v-else>Neues Passwort setzen</b-button>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { errorHandler, validateField } from '@/helpers/formHelper.js'

  const getInitialData = () => ({
    form: {
      token: '',
      newPassword: ''
    }
  })

  export default {
    components: {
      ValidationObserver,
      ValidationProvider
    },
    data: () => ({
      isSubmitting: false,
      isSucceded: false,
      hasUnknownError: false,
      unknownErrorMessage: '',
      hasError: false,
      errorMessage: '',
      isTokenValid: '',
      ...getInitialData()
    }),
    created () {
      this.checkToken()
    },
    methods: {
      checkToken () {
        this.isSubmitting = true
        const { token } = this.$route.params
        this.form.token = token

        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('user/CHECK_PASSWORD_TOKEN', token).then(res => {
          const { data, errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }

          const { ok: isTokenValid } = data.userPasswordTokenIsValid
          this.isTokenValid = isTokenValid
          this.isSubmitting = false
        }).catch(err => {
          this.isSubmitting = false
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      onSubmit () {
        this.hasUnknownError = false
        this.hasError = false

        this.$store.dispatch('user/RESET_PASSWORD', this.form).then(res => {
          const { errors } = res

          if (errors) {
            return errorHandler(this, errors)
          }

          this.isSucceded = true
          this.reset()
        }).catch(err => {
          this.hasUnknownError = true
          this.unknownErrorMessage = this.$t('formError.unknownwError')
          console.error(err)
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      },
      reset () {
        Object.assign(this.$data, getInitialData())
        requestAnimationFrame(() => {
          this.$refs.observer.reset()
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .login-spacing{
    margin-top: 7rem;
  }
  .login-form-wrapper{
    max-width: 320px;
    margin: 0 auto;
  }
  .alert-success a{
    color: #155724;
  }
</style>
